<template>
  <div class="review">
    <div class="query-item">
      <div class="search-l">
        <div v-if="!store.roles.includes('carEnterprise')" style="margin-right: 30px">
          测试主体
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.deptName"></a-input>
        </div>
        <div>
          测试牌照
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.testCarNum"></a-input>
        </div>
        <div class="ml30">
          脱离时间
          <a-range-picker class="ml24" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" @change="timeChange"
            v-model:value="time" />
        </div>
        <a-button class="ml24" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
        <div></div>
      </div>
      <!-- <div v-if="store.roles.includes('carEnterprise')">
        <a-button class="ml24" @click="add" type="primary"
          >上传脱离报告</a-button
        >
      </div> -->
      <div v-if="store.hasPermi('report:departure:download')">
        <a-button class="ml24" @click="downloadHandle" type="primary"
        >下载</a-button
        >
      </div>
    </div>
    <a-table :columns="store.roles.includes('carEnterprise') ? columns : columns2" :row-key="(record) => record.id"
      :data-source="dataSource" class="mt23" size="middle" :pagination="pagination" :scroll="{ x: 1500, y: 'auto' }"
      :row-selection="rowSelection"
      v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'createTime'">
          {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template v-if="column.key === 'action'">
          <span v-if="!store.roles.includes('carEnterprise')">
            <a class="mr10" @click="detail(record)">详情</a>
            <a-popconfirm title="确定删除?" ok-text="确定" cancel-text="取消" @confirm="del(record)">
              <a class="ml10">删除</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a @click="editReport(record)">完善报告</a>
            <a class="mr10" @click="detail(record)">详情</a>
            <a-popconfirm title="确定删除?" ok-text="确定" cancel-text="取消" @confirm="del(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
    <disengagementDrawer :drawerTitle="drawerTitle" ref="disengagementRef" @drawerEvent="drawerEvent">
    </disengagementDrawer>
  </div>
</template>
<script setup name="task">
import {ref, reactive, toRefs, onBeforeMount, onMounted, nextTick, computed} from "vue";
import { useRouter } from "vue-router";
import { FileTextOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import useUserStore from "@/store/modules/user";
import { getCars } from "@/api/car/car.js";
import disengagementDrawer from "./components/drawer.vue";
import {
  selectPageList,
  insertOne,
  editOne,
  deleteBatch,
  download
} from "@/api/report/disengagement.js";

const router = useRouter();
const store = useUserStore();

const title = ref("");
const columns = [
  {
    title: "序号",
    dataIndex: "ranking",
    key: "ranking",
    width: 100,
    fixed: "left",
  },
  {
    title: "测试牌照",
    key: "testCarNum",
    dataIndex: "testCarNum",
  },
  {
    title: "脱离时间",
    key: "departureTimeStr",
    dataIndex: "departureTimeStr",
    width: 160,
  },
  {
    title: "脱离地点",
    key: "departurePoint",
    dataIndex: "departurePoint",
  },
  {
    title: "上传时间",
    key: "updateTimeStr",
    dataIndex: "updateTimeStr",
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 150,
  },
];

const columns2 = [
  {
    title: "序号",
    dataIndex: "ranking",
    key: "ranking",
    width: 100,
    fixed: "left",
  },
  {
    title: "测试主体",
    dataIndex: "deptName",
    key: "deptName",
    width: 200,
  },
  {
    title: "测试牌照",
    key: "testCarNum",
    dataIndex: "testCarNum",
  },
  {
    title: "脱离时间",
    key: "departureTimeStr",
    dataIndex: "departureTimeStr",
    width: 160,
  },
  {
    title: "脱离地点",
    key: "departurePoint",
    dataIndex: "departurePoint",
  },
  {
    title: "更新时间",
    key: "updateTimeStr",
    dataIndex: "updateTimeStr",
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 150,
  },
];

const time = ref([]);

let query = reactive({
  testCarNum: "",
  startDateStr: "",
  endDateStr: "",
  deptName: "",
});

const timeChange = (value) => {
  console.log(value);
  query.startDateStr = value[0];
  query.endDateStr = value[1];
};

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.testCarNum = "";
  query.startDateStr = "";
  query.endDateStr = "";
  query.deptName = "";
  time.value = [];
  pagination.current = 1;
  getData();
};

let dataSource = ref([]);

const exportLoading = ref(false);
const selectedRowKeys = ref([]);
// 是否全选
const isSelectAll = ref(false);

// 行选择配置
const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: (selectedKeys) => {
    selectedRowKeys.value = selectedKeys;
  },
  onSelectAll: (selected) => {
    isSelectAll.value = selected;
    if (!selected) {
      selectedRowKeys.value = [];
    }
  },
}));

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 20, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;

  // 获取表格数据
  getData();
}

function pageSizeChange(current, size) {
  console.log(size);
  pagination.pageSize = size;

  // 获取表格数据
  getData();
}

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query },
  };
  selectPageList(data).then((res) => {
    console.log(res);
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};

const del = (record) => {
  console.log(record);
  deleteBatch({
    deleteIds: [record.id],
  }).then((res) => {
    if (res.code === 200) {
      message.success("删除报告成功");
      getData();
    }
  });
};
const drawerTitle = ref("");
const disengagementRef = ref();
const editId = ref('')

const add = () => {
  drawerTitle.value = "上传脱离报告";
  disengagementRef.value.showDrawer();
};

const editReport = (record) => {
  console.log(record);
  editId.value = record.id
  drawerTitle.value = "完善报告";
  disengagementRef.value.showDrawer(record);
};
const detail = (record) => {
  console.log(record);
  drawerTitle.value = "报告详情";
  disengagementRef.value.showDrawer(record);
};

const drawerEvent = (info) => {
  if (drawerTitle.value === "上传脱离报告") {
    console.log(info);
    insertOne(info).then(res => {
      if (res.code === 200) {
        message.success('新增成功')
        getData()
      }
    })
  } else {
    console.log(info);
    editOne({ ...info, id: editId.value }).then((res) => {
      if (res.code === 200) {
        message.success("编辑成功");
        getData();
      }
    });
  }
};

const downloadHandle = async () => {
  try {
    exportLoading.value = true;
    const data = {
      ids: selectedRowKeys.value
    };

    if (selectedRowKeys.value.length === 0) {
      message.error('请选择要导出的数据...');
      return;
    }

    console.log("data", data)

    // 等待下载完成
    const result = await download(data);
    if (result.success) {
      message.success('导出成功');
    }
  } catch (error) {
    console.error('导出失败:', error);
    message.error('导出失败');
  } finally {
    exportLoading.value = false;
  }
}

onMounted(async () => {
  getData();
});
</script>
<style lang="less" scoped>
.review {
  padding: 13px 20px 20px 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

.modal_item {
  padding: 0 26px 106px 23px;
  background: #f6f8fa;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;

  .file_text {
    padding-top: 19px;
    border-bottom: 1px solid #d4e0f0;

    .fil_it {
      display: flex;
      align-items: center;
      padding-left: 49px;
      padding-bottom: 19px;

      .file_tit {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #6c7683;
      }

      .file_ic {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1d2129;
      }
    }

    .file_icon {
      color: rgba(24, 111, 242, 1);
    }
  }
}

.mr10 {
  margin-left: 10px;
}

a {
  color: #1e8ef2;
}

.radio_class {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: rgba(29, 33, 41, 1);
}

.area_class {
  // display: flex;
}

.area_width {
  // width: 420px;
  // margin-left: 26px;
  margin-top: 22px;
}

.mt22 {
  margin-top: 22px;
}

.mt32 {
  margin-top: 32px;
}

.mb85 {
  margin-bottom: 85px;
}

.mb26 {
  margin-bottom: 26px;
}

.ml26 {
  margin-left: 26px;
}

.pl30 {
  padding-left: 30px;
}

.pl43 {
  padding-left: 43px;
}

.pl15 {
  padding-left: 15px;
}

.pl55 {
  padding-left: 55px;
}

.pl89 {
  padding-left: 89px;
}

.pl91 {
  padding-left: 91px;
}

.detail {
  padding: 75px 80px 30px 80px;

  .cars {
    border: 1px solid #e1e7ef;
    margin-bottom: 24px;

    .tit {
      background: #f6f8fa;
      padding: 11px 33px;
      font-weight: 600;
      color: #1d2129;
    }

    .cont {
      padding: 15px 28px;
    }
  }

  .filelist {
    border: 1px solid #e1e7ef;
    padding: 20px 0;
    text-align: center;

    .item {
      color: #636d7b;
      font-size: 14px;

      .anticon {
        color: #186ff2;
        margin-right: 13px;
      }
    }

    .btns {
      margin-top: 19px;
    }
  }

  .file_text {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #1d2129;
  }

  .into {
    font-size: 14px;
    color: #636d7b;
    margin: 16px 0;
  }

  .update_btn {
    cursor: pointer;
    display: inline-block;
    padding: 2px 0;
    width: 100px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #636d7b;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #636d7b;
    text-align: center;
  }
}

.add {
  .cars {
    display: flex;
    align-items: center;
    border: none;

    .tit {
      background-color: transparent;
      width: 85px;
      padding: 11px 0;
    }

    .cont {
      padding: 0;
      width: 100%;
    }
  }

  .filelist {
    text-align: center;
    background: #f6f8fa;
  }
}

.update_btn {
  cursor: pointer;
  padding: 3px 0;
  width: 100px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #636d7b;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #636d7b;
  text-align: center;
  margin: 20px auto 0;
}

.upload_a {
  display: inline-block;
  width: 60px;
  height: 32px;
  background: #1e8ef2;
  color: #fff;
  box-shadow: 0 2px 0 rgba(8, 96, 137, 0.17);
  padding: 4px 15px;
  border-radius: 4px;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

/deep/.ant-tabs .ant-tabs-tab {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  margin: 0 0 0 70px;
  color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #1d2129;
}

/deep/.ant-tabs-nav {
  margin-bottom: 24px;
}

/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
  height: 3px;
  // background: rgba(30, 142, 242, 1);
}

/deep/.ant-upload-wrapper .ant-upload-list {
  width: 130px;
}
</style>
